const styles = theme => ({
  popup: {
    padding: '8px',
    backgroundColor: '#fff',
    borderRadius: '8px',
    width: '100%',
    maxWidth: '800px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '16px',
    textAlign: 'center',
    maxHeight: '75vh',
    overflow: 'auto',
  },
  logo: {
    width: '150px',
    height: 'auto',
  },
  title: {
    fontSize: '20px',
    fontWeight: 500,
  },
  description: {
    color: '#5865F2',
    fontSize: '20px',
    fontWeight: 500,
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  iframe: {
    height: '340px',
    width: '600px',
    border: 'none',
    borderRadius: '8px',
  },
  button: {
    backgroundColor: '#fff',
    color: '#5865F2',
    padding: '10px 24px',
    borderRadius: '20px',
    textDecoration: 'none',
    fontSize: '14px',
    fontWeight: 600,
    border: '1px solid #5865F2',
  },
  note: {
    backgroundColor: '#E3F3FF',
    padding: '16px',
    borderRadius: '8px',
    color: '#666',
    fontSize: '16px',
    fontWeight: 400,
    maxWidth: '600px',
  },
  noteTitle: {
    fontWeight: 600,
  },
})

export default styles
